import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref } from "vue";
import OfferChangeHistoryItem from "@/components/offers/offer/OfferChangeHistoryItem.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import BaseTable from "@/components-UI/table/BaseTable.vue";
import { CellsType, prepareItems, RawConfig } from "@/utils/CellsFactory";
import { IChangesHistoryItem } from "@/api/types/offers";
import { ITableHeader } from "@/utils";

interface Props {
    offer: OfferSingle;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferChangeHistory',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle;
}



const isLoading = ref(true);
const total = ref(0);
const rawItems = ref([]);
const page = ref(1);

const headers: ITableHeader[] = [
    { text: 'Дата/время обновления', value: 'changed_at', sortable: false, width: '150px' },
    { text: 'Объект', value: 'translated_subject', sortable: false },
    { text: 'ID Объекта', value: 'subject_id', sortable: false, align: 'center' },
    { text: 'Какое поле изменено', value: 'translated_filed', sortable: false },
    { text: 'Старое значение', value: 'old_value', sortable: false, width: '250px' },
    { text: 'Новое значение', value: 'new_value', sortable: false, width: '250px' },
    { text: 'Кем изменено', value: 'changed_by', sortable: false, align: 'center', width: '200px' },
];

onBeforeMount(() => {
    updateTable();
});

const changePage = (val: number) => {
    page.value = val;
    updateTable();
};

const updateTable = async () => {
    const { total: t, data } = await props.offer.getHistoryChanges(page.value === 1 ? 0 : page.value)
        .finally(() => isLoading.value = false);
    total.value = t;
    rawItems.value = data;
    formatItems();
};

const formattedItems = ref([]);

const cellsConfigs: RawConfig<IChangesHistoryItem> = {
    [CellsType.Date]: {
        changed_at: {},
    },
    [CellsType.Uniq]: {
        subject_id: {},
        old_value: {},
        new_value: {},
    },
};

const formatItems = () => {
    const columns = headers.map(h => h.value);
    formattedItems.value = prepareItems(rawItems.value, cellsConfigs, columns);
};

return { __sfc: true,props, isLoading, total, rawItems, page, headers, changePage, updateTable, formattedItems, cellsConfigs, formatItems, OfferChangeHistoryItem, BaseTable }
}

})